import { useStaticQuery, graphql } from 'gatsby';

const AnnouncementBanner = () => {
  const { datoCmsSiteMetaInfo = {} } = useStaticQuery(graphql`
    query AnnouncementQuery {
      datoCmsSiteMetaInfo {
        announcement
      }
    }
  `);

  if (!datoCmsSiteMetaInfo?.announcement) return null;

  return (
    <div className="flex w-full items-center justify-center bg-orange-400 px-cove-25 py-cove-15 text-base font-semibold">
      {datoCmsSiteMetaInfo.announcement}
    </div>
  );
};

export default AnnouncementBanner;
